import React from 'react';
import ReactDOM from 'react-dom/client';
import { MemberstackProvider } from "@memberstack/react";
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Theme from "./Theme";
import { GlobalStyle } from "./style/GlobalStyle";

if (process.env.NODE_ENV === 'production') {
  ['log', 'debug', 'info'].forEach((m) => { console[m] = () => {}; });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const config = { publicKey: process.env.REACT_APP_MEMBERSTACK_PUBLIC_KEY || "pk_sb_7f2cb68f80d96a32b8ab" }

root.render(
  <Theme>
    <React.StrictMode>
      <MemberstackProvider config={config}>
        <App />
      </MemberstackProvider>
      <GlobalStyle />
    </React.StrictMode>
  </Theme>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
